import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import './SelectDashboard.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const SelectDashboard = () => {
  const history = useHistory();
  const [configuredProviders, setConfiguredProviders] = useState({});
  const [loading, setLoading] = useState(true);

  const dashboards = [
    {
      id: 'claude',
      name: 'Claude Dashboard',
      description: 'Monitor Claude API usage, costs, and analytics',
      icon: '🤖',
      route: '/claude'
    },
    {
      id: 'gemini',
      name: 'Gemini Dashboard',
      description: 'Track Gemini model performance and usage',
      icon: '💎',
      route: '/gemini'
    },
    {
      id: 'openai',
      name: 'OpenAI Dashboard',
      description: 'Analyze OpenAI API metrics and spending',
      icon: '🔮',
      route: '/openai'
    },
    {
      id: 'grok',
      name: 'Grok Dashboard',
      description: 'View Grok AI usage statistics',
      icon: '⚡',
      route: '/grok'
    }
  ];

  useEffect(() => {
    fetchConfiguredProviders();
  }, []);

  const fetchConfiguredProviders = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/keys/status`);
      setConfiguredProviders(response.data);
    } catch (error) {
      console.error('Error fetching provider status:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDashboardClick = (dashboard) => {
    const isConfigured = configuredProviders[dashboard.id]?.configured;
    if (isConfigured) {
      history.push(dashboard.route);
    } else {
      // Redirect to setup page
      history.push(`/${dashboard.id}_setup`);
    }
  };

  const handleBackToSetup = () => {
    history.push('/main_app');
  };

  if (loading) {
    return (
      <div className="dashboard-selection">
        <div className="loading">Loading...</div>
      </div>
    );
  }

  return (
    <div className="dashboard-selection">
      <div className="dashboard-selection-header">
        <div className="header-content">
          <button onClick={handleBackToSetup} className="back-to-setup-btn" title="Back to Setup">
            ← Setup
          </button>
          <div>
            <h1>Select Dashboard</h1>
          </div>
        </div>
      </div>

      <div className="dashboard-selection-container">
        <h2>Choose a Dashboard</h2>
        <p className="subtitle">View metrics for your configured LLM providers</p>

        <div className="dashboard-grid">
          {dashboards.map((dashboard) => {
            const isConfigured = configuredProviders[dashboard.id]?.configured;
            return (
              <div
                key={dashboard.id}
                className={`dashboard-card ${!isConfigured ? 'not-configured' : ''}`}
                onClick={() => handleDashboardClick(dashboard)}
              >
                <div className="dashboard-icon">{dashboard.icon}</div>
                <h3>{dashboard.name}</h3>
                <p>{dashboard.description}</p>
                {isConfigured ? (
                  <span className="status-badge configured">✓ Configured</span>
                ) : (
                  <span className="status-badge not-configured-badge">Setup Required</span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SelectDashboard;
